import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv } from "@fortawesome/free-solid-svg-icons";
import Papa from "papaparse";

const ExportCSVButton = ({ data, filename, className }) => {
  const handleExportCSV = () => {
    // Configure CSV options for better formatting and handling special characters
    const csv = Papa.unparse(data, {
      quotes: true, // Put quotes around all fields
      header: true, // Include header row
      skipEmptyLines: true, // Skip empty lines in the output
    });

    // Create and download the file
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link); // Required for Firefox
    link.click();
    document.body.removeChild(link); // Clean up
    URL.revokeObjectURL(link.href); // Free up memory
  };

  return (
    <button
      onClick={handleExportCSV}
      className={
        className ||
        "px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md flex items-center transition ease-in-out duration-150"
      }
    >
      <FontAwesomeIcon icon={faFileCsv} className="mr-2" />
      Export as CSV
    </button>
  );
};

export default ExportCSVButton;
